<template>
  <data-section
    theme="blue"
    title="其他產險-火險"
    :isLoading="isLoading"
    :datas="highlightModify"
    :_fields="
      [
        {
          name: '保單號碼',
          key: 'ceplcno',
          width: 155,
          sortable: true,
          orderByMultiKey: ['ceplcno'],
          orderByMultiType: ['asc'],
        },
        {
          name: '產險公司',
          key: 'comp_nm',
          width: 410,
          sortable: true,
          orderByMultiKey: ['comp_nm'],
          orderByMultiType: ['asc'],
        },
        {
          name: '契約別',
          key: 'contract_type',
          width: 110,
          sortable: true,
          orderByMultiKey: ['contract_type'],
          orderByMultiType: ['asc'],
        },
        {
          name: '被保人',
          key: 'ceisdnm',
          width: 94,
          sortable: true,
          className: 'link text-underline',
          orderByMultiKey: ['ceisdnm'],
          orderByMultiType: ['asc'],
        },
        {
          name: '有效期間',
          key: 'celpsdt',
          width: 110,
          sortable: true,
          className: 'text-left',
          orderByMultiKey: ['celpsdt'],
          orderByMultiType: ['asc'],
        },
        {
          name: '保費',
          key: 'premium',
          width: 83,
          sortable: true,
          thClassName: 'text-right',
          className: 'text-right',
          orderByMultiKey: ['premium1'],
          orderByMultiType: ['asc'],
        },
        {
          name: '建築完工年份',
          key: 'target_birth',
          width: 108,
          sortable: true,
          className: 'text-left',
          orderByMultiKey: ['target_birth'],
          orderByMultiType: ['asc'],
        },
      ].concat(_fields)
    "
    @toggle="
      (isShow) =>
        $router.assignQuery({ OtherPropertyFireInsuranceShow: isShow })
    "
    :initShow="$route.query['OtherPropertyFireInsuranceShow'] !== 'false'"
  >
    <template scope="props" v-if="refresh">
      <data-table
        v-bind="props"
        @changeSort="
          (sort) =>
            $router.assignQuery({
              [`OtherPropertyFireInsuranceSort`]: JSON.stringify(sort),
            })
        "
        :initSort="
          $route.query[`OtherPropertyFireInsuranceSort`]
            ? JSON.parse($route.query[`OtherPropertyFireInsuranceSort`])
            : null
        "
      >
        <template slot="celpsdt" scope="item">
          <div
            class="pre-formatted"
            v-html="
              buildStartEndString(
                getROCDate(item.data.ceplcdt),
                getROCDate(item.data.celpsdt)
              )
            "
          ></div>
        </template>
        <template slot="ceisdnm" scope="item">
          <span
            @click="routeToCustDetail(item.data.ceisdno, item.data.ceisdnm)"
          >
            {{ item.data.ceisdnm | truncate }}
          </span>
        </template>
        <template slot="contract_type" scope="item">
          {{ translate.fireContractType[item.data.contract_type] }}
        </template>
        <template slot="premium" scope="item">
          {{ item.data.premium1 | numberFormat }}元
        </template>
        <template slot="target_birth" scope="item">
          {{ item.data.target_birth ? item.data.target_birth + "年" : "" }}
        </template>
        <template slot="action" scope="item">
          <div class="dropdown">
            <a
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              class="btn btn-icon btn-default btn-sm"
              role="button"
            >
              <i class="icon-more"></i>
            </a>
            <div class="dropdown-menu">
              <a
                role="button"
                class="dropdown-item text-green text-underline"
                @click="toUpdate(item.data.pt_contractx_id)"
                >修改</a
              >
              <a
                role="button"
                class="dropdown-item text-green text-underline"
                @click="doDelete(item.data)"
                >刪除</a
              >
            </div>
          </div>
        </template>
      </data-table>
    </template>
  </data-section>
</template>

<script>
import InsuranceMixins from "./Insurance";
import HighlightModify from "./HighlightModify";
import { contract_type_enum } from "@/desktop/contract/FireInsuranceContractTypes";
import { deleteOtherPropertyInsurance } from "@/service";

export default {
  mixins: [InsuranceMixins, HighlightModify],
  data() {
    return {
      translate: {
        fireContractType: {
          0: "住宅火險",
          1: "商業火險",
          2: "住家綜合保險",
          3: "地震保險",
        },
      },
    };
  },
  methods: {
    toUpdate(pt_contractx_id) {
      this.$router.push({
        name: "fire-insurance",
        query: {
          pt_contractx_id,
        },
      });
    },
    async doDelete(data) {
      await this.$deleteConfirm(
        this.buildDeleteMessage(
          `${data.ceplcno} ${contract_type_enum[data.contract_type]}`
        )
      );
      await this.deleteSuccessHandler(
        deleteOtherPropertyInsurance({
          pt_contractx_id: data.pt_contractx_id,
        })
      );
      this.isLoading = true;
      this.$bus.emit(
        "other-property-insurance.get",
        () => (this.isLoading = false)
      );
    },
  },
};
</script>
